// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__14tss","rootSuccess":"CompleteLink_rootSuccess__16xPE","rootFailure":"CompleteLink_rootFailure__bXFjH","isDisabled":"CompleteLink_isDisabled__2UKF0"};